import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/specifygwa/frontend/components/commercetools-ui/organisms/idle-time-logout/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/specifygwa/frontend/frontastic/renderer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/specifygwa/frontend/frontastic/tastics/not-found/index.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/specifygwa/frontend/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/opt/build/repo/packages/specifygwa/frontend/providers/index.tsx");
